import { Group } from '@mantine/core';
import { useMemo } from 'react';
import type { Outcome } from '../../../../api/strategy-client/strategy-client.type';
import { useTranslation } from 'react-i18next';
import { OverviewCard } from '../../../../components/overview-card/overview-card';
import { skyDark } from '../../../../styles/design-tokens';
import { Icon } from '../../../../ui-library/icon/icon';
import {
  getOutcomeProgressChart,
  getOutcomeStatusChart,
  getRiskCategoryBreakdownChart,
} from '../risk-analysis-chart.helpers';

type Props = {
  outcomes: Outcome[];
};

export const RiskAnalysisOutcomesOverview = ({ outcomes }: Props) => {
  const i18n = useTranslation();
  const outcomeStatusChart = useMemo(() => {
    return getOutcomeStatusChart(outcomes);
  }, [outcomes]);

  const riskCategoryBreakdownChart = useMemo(() => {
    return getRiskCategoryBreakdownChart(outcomes);
  }, [outcomes]);

  const outcomeProgressChart = useMemo(() => {
    return getOutcomeProgressChart(outcomes);
  }, [outcomes]);

  return (
    <Group>
      <OverviewCard
        title={`${i18n.t('common.outcomes')} by Status`}
        icon={<Icon name="insert_chart_outlined" size={20} color={skyDark} />}
        content={outcomeStatusChart}
      />
      <OverviewCard
        title="Risk Category Breakdown"
        icon={<Icon name="bar_chart" size={20} color={skyDark} />}
        content={riskCategoryBreakdownChart}
      />
      <OverviewCard
        title="Average Progress"
        icon={<Icon name="check_circle" size={20} color={skyDark} />}
        content={outcomeProgressChart}
      />
    </Group>
  );
};
